<template>
  <div>
    <!-- <img :src="profile.picture" alt="User's profile picture"> -->
    <el-row :gutter="40">
      <el-col :span="8">
        <el-image v-if="user.photoURL"style="width: 100px; height: 100px; border: 1px solid #eee" :src="user.photoURL" fit="cover"><div slot="error"></div></el-image>
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item label="Email" prop="email" v-if="$store.state.user.isAnonymous != true">
            <el-input v-model="user.email" type="email" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="ID">
            <el-input v-model="user.uid" type="text" :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item label="Имя">
            <el-input v-model="user.displayName" clearable type="text"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="Аватарка">
            <el-upload
              class="upload-demo"
              drag
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
              <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
            </el-upload>
          </el-form-item>  -->
          <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('form')">Сохранить</el-button>
          </el-form-item> -->
        </el-form>
      </el-col>
    </el-row>
    <!-- <pre><code>{{ JSON.stringify(profile, null, 2) }}</code></pre> -->    
    <div v-if="collectionList.length > 0">
      <hr>
      <el-button @click="removeCollection();">Очистить всю коллекцию</el-button>
      <el-button @click="hiddenAllMod();">Скрыть все модификации</el-button>
      <el-button @click="showAllMod();">Показать все модификации</el-button>
      <hr>
      <h2>Модификации предметов</h2>
      <el-row :gutter="40">
        <el-col :span="16">
          <el-table :data="collectionList" border ref="collectionList">
            <el-table-column label="Название" prop="mod">
              <template slot-scope="scope">
                  <span>{{scope.row.modName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Количество предметов" prop="size" width="240">
              <template slot-scope="scope">
                  <span>{{scope.row.size}}</span>
              </template>
            </el-table-column>  
            <el-table-column label="Действие" prop="event" align="right" width="200">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="removeMod(scope.row.mod);">Очистить</el-button>
                  <span v-if="$store.state.user.uid != 'cwPdIDPREeWuZVco6GhF2xGQX6u2'">
                    <el-button v-if="hiddenMods.indexOf(scope.row.mod) == -1" size="mini" @click="hiddenMod(scope.row.mod);">Скрыть</el-button>
                    <el-button v-if="hiddenMods.indexOf(scope.row.mod) != -1" size="mini" @click="showMod(scope.row.mod);">Показать</el-button>
                  </span>
                </el-button-group>    
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <hr> 
    <el-button icon="el-icon-s-custom" id="qsLogoutBtn" @click="logout()" v-if="$store.state.user.isAnonymous != true">Выйти из аккаунта</el-button>
    <el-button @click="$router.push({name: 'Login'})" v-if="$store.state.user.isAnonymous == true">Войти в аккаунт</el-button>
    <el-button @click="$router.push({name: 'SignUp'})" v-if="$store.state.user.isAnonymous == true">Создать аккаунт</el-button>
    <el-button id="qsLogoutBtn" @click="removeProfile()" v-if="$store.state.user.uid != 'cwPdIDPREeWuZVco6GhF2xGQX6u2'">Удалить <span v-if="$store.state.user.isAnonymous == true">профиль</span><span v-if="$store.state.user.isAnonymous != true">аккаунт</span></el-button> 
  </div>  
</template>

<script>
// import firebase from 'firebase';
import firebase from 'firebase/app';
require('firebase/auth');
import {db} from '../firebase.js';
import {modsList} from '../functions.js';
// import { mapState } from 'vuex';
export default {
  data() {
    return {
      form: {},
      user: {
        displayName: '',
        email: '',
        uid: '',
        photoURL: '',
      },
      rules: {
        name: [
          {required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
        ],
      },
      profile: {},
      recomputedCList: 0,
      activeMods: [],
      passiveMods: [],
      hiddenMods: [],
    };
  },
  computed: {
    collectionList() {
      var self = this;
      var recomputedCList = self.recomputedCList;
      var collectionList = [];
      modsList.forEach(el=>{
        var size = (self.$store.state.userCollection[el.value]) ? self.$store.state.userCollection[el.value].length : 0;
        collectionList.push({mod: el.value, modName: el.label, size: size});
      });
      return collectionList;
    },
  },
  mounted() {
    var self = this;
    // console.log(self.$store.state.userOptions);
    if (self.$store.state.userOptions != undefined){
      self.hiddenMods = self.$store.state.userOptions.hiddenMods || [];
    };
    this.$store.subscribe((mutation, state) => {
      switch(mutation.type) {
        case 'updateUserOptions':
          if (self.$store.state.userOptions) {
            self.hiddenMods = self.$store.state.userOptions.hiddenMods || [];
          };
        break;
      };       
    });
    if (this.$store.state.user) {
      self.setProp();
    } else {
      this.$store.subscribe((mutation, state) => {
        switch(mutation.type) {
          case 'updateUser':
            self.setProp();
          break;
        };
      });
    };
    for (var prop in self.$store.state.userCollection) {
      if (self.$store.state.userCollection[prop].length > 0) {
        self.activeMods.push(prop);
        self.$store.state.userCollection[prop].forEach(el=>{
          if (el.priceType == "recipePrice") { 
            for (var subProp in el.key) {
              if (self.passiveMods.indexOf(el.key[subProp].mod) == -1 && self.activeMods.indexOf(el.key[subProp].mod) == -1) {
                self.passiveMods.push(el.key[subProp].mod);
              };
            };
          };
        });
        self.$store.state.itemCollection[prop].forEach(el=>{
          for (var subProp in el.key) {
            if (self.passiveMods.indexOf(el.key[subProp].mod) == -1 && self.activeMods.indexOf(el.key[subProp].mod) == -1) {
              self.passiveMods.push(el.key[subProp].mod);
            };
          };
        });
      };
    };
  },
  methods: {
    removeUserDoc(){
      var self = this;
      var profileName = (self.$store.state.user.isAnonymous == true) ? 'Профиль' : 'Аккаунт';
      db.collection('users').doc(self.$store.state.user.uid).get().then(doc=>{
        doc.ref.delete().then(function(){
          self.$store.state.user.delete().then(function() {
            self.$notify({title: 'Успех', message: profileName + ' успешно удалён', type: 'success'});
            document.location.reload(true);
          }).catch(function(error) {
          });
        });
      });
    },
    removeProfile(consent){
      var self = this;
      var profileName = (self.$store.state.user.isAnonymous == true) ? 'профиль' : 'аккаунт';
      var consent = (consent) ? consent : confirm('Вы уверены что хотите удалить ' + profileName + '?');
      if (consent) {
        db.collectionGroup('recipes').where("author", "==", self.$store.state.user.uid).get().then(function(querySnapshot){
          var size = querySnapshot.size;
          if (size != 0) {
            querySnapshot.forEach(function(doc){
              doc.ref.delete().then(function(){
                size--;
                self.removeUserDoc();
                if (size == 0) {
                  self.removeUserDoc();
                };
              }); 
            }); 
          } else {
            self.removeUserDoc();
          };        
        }).catch(function(error) {
        });
      };
    },
    logout() {
      var self = this;
      var consent = confirm('Вы уверены что хотите выйти из профиля?');
      if (consent) {
        if (self.$store.state.user.isAnonymous) {
          self.removeProfile(consent);
        } else {
          firebase.auth().signOut().then(() => {
            document.location.reload(true);
          });
        };
      };  
    },
    removeCollection(){
      var self = this;
      var consent = confirm('Вы уверены что хотите удалить все предметы своей коллекции?');
      if (consent) {
        db.collectionGroup('recipes').where("author", "==", self.$store.state.user.uid).get().then(function(querySnapshot){
          var size = querySnapshot.size;
          querySnapshot.forEach(function(doc) {
            doc.ref.delete().then(function(){
              size--;
              if (size == 0) {
                self.$store.commit('updateUserCollection', {userCollection: {}});
                self.recomputedCList++;
                self.$notify({title: 'Успех', message: 'Ваша коллекция успешно очищена', type: 'success'});
                // console.log(self.$store.state.userCollection);
              };
            });
          });
        });
      };  
    },
    showMod: function(mod){
      var self = this;
      var hiddenMods = self.$store.state.userOptions.hiddenMods;
      hiddenMods.splice(hiddenMods.indexOf(mod), 1);
      self.setUserModVisibility(hiddenMods);
    },
    showAllMod(){
      var self = this;
      var hiddenMods = [];
      self.setUserModVisibility(hiddenMods);
    },
    setUserModVisibility(hiddenMods){
      var self = this;
      var data = {hiddenMods: hiddenMods};
      var doc = db.collection('users').doc(self.$store.state.user.uid);
      doc.update(data).then(function(){
        self.$notify({title: 'Успех', message: 'Настройки видимости модификаций успешно сохранены', type: 'success'});
      }).catch((error) => {
        doc.set(data).then(function(){
          self.$notify({title: 'Успех', message: 'Настройки видимости модификаций успешно сохранены', type: 'success'});
        });
      });    
    },
    hiddenAllMod(){
      var self = this;
      var collection = self.$store.state.userCollection;
      var hiddenMods = [];
      // console.log(self.$store.state.userCollection);
      // if (Object.keys(collection).length === 0 && collection.constructor === Object) {
      if (Object.keys(collection).length === 0) {  
        hiddenMods = self.collectionList.map(el=>{return el.mod});
        self.setUserModVisibility(hiddenMods);
      } else {
        self.$notify({title: 'Ошибка', message: 'Нельзя скрыть все модификации, так как в Вашей коллекции присутствуют предметы.', type: 'error'});
      };
    },
    hiddenMod: function(mod){
      var self = this;
      // console.log(self.passiveMods);
      if (self.activeMods.indexOf(mod) == -1 && self.passiveMods.indexOf(mod) == -1) {
        var hiddenMods = [];
        if (self.$store.state.userOptions != undefined){
          hiddenMods = self.$store.state.userOptions.hiddenMods || [];
        };  
        if (hiddenMods.indexOf(mod) == -1) {hiddenMods.push(mod)};
        self.setUserModVisibility(hiddenMods);
      } else {
        self.$notify({title: 'Ошибка', message: 'Предметы из этой модификиции встречаются (могут встречаться) в рецептах Ваших предметов, поэтому скрыть эту модификицию нельзя', type: 'error'});
      };
    },
    removeMod: function(mod){
      var self = this;
      var consent = confirm('Вы уверены что хотите удалить все предметы этой модификации из своей коллекции?');
      if (consent) {
        db.collection('mods').doc(mod).collection('recipes').doc(self.$store.state.user.uid).delete().then(function(){
          var userCollection = self.$store.state.userCollection;
          delete userCollection[mod];
          self.$store.commit('updateUserCollection', {userCollection: userCollection});
          self.recomputedCList++;
          self.$notify({title: 'Успех', message: 'Модификация и все её предметы успешно удалёны из Вашей коллекции', type: 'success'});
        });
      };
    },
    submitForm: function(formName) {
      var self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var resipesDB = db.collection('users').where("displayName", "==", self.user.displayName).get().then(function(docs) {
            if (docs.empty) {
              db.collection('users').doc(self.user.uid).set({
                displayName: self.user.displayName,
                rating: 0,
              }).then(function(){
                self.profile.updateProfile({
                  displayName: self.user.displayName,
                });
              })
            } else {
              alert('Пользователь с таким именем уже существует. Подберите другое имя.');
            };
          });  
        } else {
          // console.log('error submit!!');
          return false;
        };
      });
    },
    setProp() {
      var self = this;
      self.profile = self.$store.state.user;
      self.user.displayName = self.profile.displayName || 'Безымянный';
      self.user.email = self.profile.email;
      self.user.uid = self.profile.uid;
      self.user.photoURL = self.profile.photoURL;
    },
  }
};
</script>
